/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Wild_Jackdaw_LinkInputs */

const en_antsy_wild_jackdaw_link = /** @type {(inputs: Antsy_Wild_Jackdaw_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const de_antsy_wild_jackdaw_link = /** @type {(inputs: Antsy_Wild_Jackdaw_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Antsy_Wild_Jackdaw_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const antsy_wild_jackdaw_link = /** @type {((inputs?: Antsy_Wild_Jackdaw_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Wild_Jackdaw_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_antsy_wild_jackdaw_link(inputs)
	return de_antsy_wild_jackdaw_link(inputs)
});